import { arrayOf, bool, number, func } from "prop-types";
import { useTranslation } from "react-i18next";
import { SESSION_PLAYER_PADDING } from "../../utils";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import { PlayButton, SpeedButtons, Timer, TimerWithInactivity } from "./components";
import { makeStyles } from "@material-ui/core/styles";

export const ControlPanel = ({
  playTime,
  totalTime,
  startTime,
  inactivePeriods,
  skipInactive,
  toggleInactivity,
  
  playSpeed,
  setPlaySpeed,
  
  handleSlider,
  handleSliderCommit,
  ...playButtonProps
}) => {
  const { t } = useTranslation();
  const classes = useStyle();
  
  const timeProps = {
    totalTime,
    playTime,
  }
  
  return (
    <Grid
      item
      container
      direction="column"
      wrap="nowrap"
      className={classes.root}
    >
      <TimerWithInactivity
        { ...timeProps }
        startTime={startTime}
        inactivePeriods={inactivePeriods}
        onSliderDrag={handleSlider}
        onSliderDragEnd={handleSliderCommit}
      />
      <Grid
        item container
        justifyContent="center"
        alignItems="center"
        className="h-full text-alt px-3"
      >
        <Timer {...timeProps} className="absolute left-6" />
        <PlayButton {...timeProps} {...playButtonProps} />
        <Grid
          item container
          wrap="nowrap"
          className="w-max absolute right-6"
        >
          <SpeedButtons
            playSpeed={playSpeed}
            setPlaySpeed={setPlaySpeed}
          />
          <FormControlLabel
            label={t("views.session.skip_inactive")}
            className="ml-2 mr-0"
            classes={{ label: "text-sm" }}
            labelPlacement="start"
            control={(
              <Switch
                color="primary"
                checked={skipInactive}
                onChange={toggleInactivity}
                size="small"
                className="ml-2"
              />
            )}
          />
        </Grid
        >
      </Grid>
    </Grid>
  )
}

ControlPanel.propTypes = {
  
  isPlaying: bool.isRequired,
  playTime: number.isRequired,
  totalTime: number.isRequired,
  startTime: number.isRequired,
  endTime: number.isRequired,
  inactivePeriods: arrayOf(arrayOf(number)).isRequired,
  skipInactive: bool,
  playSpeed: number.isRequired,
  
  resume: func.isRequired,
  pause: func.isRequired,
  toggleInactivity: func.isRequired,
  setPlaySpeed: func.isRequired,
  
  handleSlider: func.isRequired,
  handleSliderCommit: func.isRequired,
}

const useStyle = makeStyles(( theme ) => ({
  root: {
    height: 68,
    margin: `0 -${SESSION_PLAYER_PADDING}px`,
    backgroundColor: theme.palette.text.primary,
    width: `calc(100% + ${2*SESSION_PLAYER_PADDING}px)`,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
}));